import { create } from "zustand";

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  emailVerified: boolean;
  image?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  signupMode: "open" | "waitlist" | null;
  isAdmin: boolean;

  setUser: (user: AuthUser | null) => void;
  setLoading: (loading: boolean) => void;
  setSignupMode: (mode: "open" | "waitlist") => void;
  setIsAdmin: (isAdmin: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  isLoading: true,
  signupMode: null,
  isAdmin: false,

  setUser: (user) => set({ user }),
  setLoading: (isLoading) => set({ isLoading }),
  setSignupMode: (signupMode) => set({ signupMode }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  clear: () => set({ user: null, isLoading: false, isAdmin: false }),
}));
